import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';

function DataList({ items }) {
  return (
    <Stack spacing={1} divider={<Divider />}>
      {items.map((i) => (
        <Stack
          key={i.key}
          direction="row"
          spacing={1}
          sx={{ alignItems: 'flex-end', justifyContent: 'space-between' }}
        >
          <Typography>{i.label}</Typography>
          <Typography>{i.value}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}

export default DataList;
